export const specialoptions = [
	{ value: 'Animated', label: 'Animated', parm: 'special' },
];